import React from "react";
import { TestiMonials } from "./Containt_home";
  
const Partenr
 = ()=>{
    return <div>
    <h1>Partenr
        
    </h1>
       <TestiMonials />;
    </div>
}
export default Partenr
;